import React from 'react';
import classNames from 'classnames';
import { Row } from 'antd';
import './index.less';

const DescriptionList = ({
  className,
  title,
  col = 3,
  gutter = 32,
  children,
  size,
  ...restProps
}) => {
  const clsString = classNames('descriptionList', 'layout');
  const column = col > 4 ? 4 : col;
  return (
    <div className={clsString} {...restProps}>
      {title ? <div className="title">{title}</div> : null}
      <Row gutter={gutter}>
        {React.Children.map(children, child =>
          child ? React.cloneElement(child, { column }) : child,
        )}
      </Row>
    </div>
  );
};

export default DescriptionList;



// WEBPACK FOOTER //
// ./src/components/comm/DescriptionList/DescriptionList.js